/**
 * Fields users may update from the client. Subscription/billing/tier fields are
 * server-only (Admin SDK / Stripe webhook).
 */

export const PROTECTED_USER_FIELDS = [
  'subscription',
  'upgradedAt',
  'stripeCustomerId',
  'stripeSubscriptionId',
  'stripeSubscriptionStatus',
  'stripeCancelAtPeriodEnd',
  'billingInfo',
  'role',
  'isAdmin',
  'isTester',
  'profileComplete',
  'blocked',
  'blockedAt',
  'blockedBy',
  'blockedFromRequestId',
  'email'
]

export const ALLOWED_CLIENT_PROFILE_FIELDS = [
  'name',
  'communityName',
  'firstName',
  'lastName',
  'phone',
  'photoURL',
  'age',
  'gender',
  'height',
  'weight',
  'address',
  'city',
  'state',
  'zipCode',
  'country',
  'stylePreferences',
  'favoriteColors',
  'budget',
  'occasion',
  'chest',
  'waist',
  'hips',
  'inseam',
  'shoulder',
  'sleeve',
  'neck',
  'shoeSize'
]

export function pickAllowedProfileFields(payload = {}) {
  const allowed = {}
  for (const key of ALLOWED_CLIENT_PROFILE_FIELDS) {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      allowed[key] = payload[key]
    }
  }
  return allowed
}

/** The Full Name typed at sign-up, tidied and capped. Empty string when blank. */
export function cleanSignupName(name) {
  return String(name || '').replace(/\s+/g, ' ').trim().slice(0, 100)
}

export function isAdminUser(user) {
  if (!user || typeof user !== 'object') return false
  return user.isAdmin === true || user.role === 'admin'
}

export function stripProtectedUserFields(payload = {}) {
  const cleaned = { ...payload }
  for (const key of PROTECTED_USER_FIELDS) {
    delete cleaned[key]
  }
  return cleaned
}
